import { required } from 'ra-core';
import { FileInput } from '../../components/admin/file-input';
import { ImageField } from '../../components/admin/image-field';
import { TextInput } from '../../components/admin/text-input';
import { maxFileSize } from '../../utils/validation';

const imageValidation = maxFileSize('5MB');

/** The badge form inputs, shared by create and edit */
export const BadgeInputs = () => (
  <>
    <TextInput source="name" validate={required()} />
    <FileInput
      source="image"
      accept={{ 'image/*': ['.jpg', '.jpeg', '.png', '.gif'] }}
      validate={imageValidation}
    >
      <ImageField
        source="src"
        title="title"
        className="[&_img]:max-h-40 [&_img]:object-contain"
      />
    </FileInput>
  </>
);
